import * as React from 'react';

interface InfoAnnieProps {
  title?: string | any;
  text?: any;
  color?: string;
  renderButton?: any;
}

export const InfoAnnie = ({ title, text = '', color = 'blue', renderButton = null }: InfoAnnieProps) => {
  const renderedButton = renderButton?.();
  return (
    <div className={'info-annie-container ' + color}>
      <div className={'annie-img'}><img src={require('./img/annie-blue.png')} alt={'Admiral'}/></div>
      <div className={'content'}>
        {title && <div className={'title'}>{title}</div>}
        {text && <div className={'text'}>{text}</div>}
      </div>
      {renderedButton && (
        <div className={'button-container'}>{renderedButton}</div>
      )}
    </div>
  )
}
